import clsx from 'clsx'
import CustomSelector from 'snippets/custom-selector/custom-selector'

function ProductVariantDropdown({ option, items, selected, setSelected, giftCard = false, isModalLayout = false }) {
  if (!items.length) return null

  const label = giftCard ? translate.product.chooseGiftCardValue : ''

  const handleChange = (value) => {
    setSelected((prev) => ({
      ...prev,
      [option]: value
    }))
  }

  const convertedOptions = items.map((item) => ({
    name: item,
    value: item
  }))

  return (
    <div className={clsx(!isModalLayout && 'border-t border-t-neutral-700 pt-6')}>
      <span className='mb-2.5 block text-xs uppercase text-neutral-900 tracking-[2px]'>{option}</span>
      <CustomSelector
        id={`variant-${option}`}
        value={selected[option] || ''}
        options={convertedOptions}
        onChange={handleChange}
        placeholder={label}
        className="w-full"
        classInput="!pt-[13px] !pb-3 !leading-none"
        classLabel="hidden"
      />
    </div>
  )
}

export default ProductVariantDropdown
